import * as React from 'react';
import { WelcomePageHeroBannerContainer } from './welcomePageHeroBanner/welcomePageHeroBannerContainer';
import { WelcomePageHighlightContainer } from './welcomePageHighlight/welcomePageHighlightContainer';
import { WelcomePageNewsBlockContainer } from './welcomePageNewsBlock/welcomePageNewsBlockContainer';

export const Frontpage: React.StatelessComponent<{}> = () => {
  return (
    <main>
      <div className="container frontpage">
			<WelcomePageHeroBannerContainer />
			<WelcomePageHighlightContainer />
			<WelcomePageNewsBlockContainer />
      </div>
    </main>
  );
}


// WEBPACK FOOTER //
// ./src/components/frontpage.tsx